module.exports = "/assets/9debe7f3a42369d301251ea54e1c0f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LO.png
// module id = 2710
// module chunks = 0